module.exports = __webpack_public_path__ + "static/media/ic-collections.6efe4a12.svg";